import React from "react";
import PropTypes from "prop-types";
import { upperCaseFirstLetter } from "lib/utils";
import { Box } from "Components/Base/Layout/Box";
import { TextField } from "Components/Base/Inputs/TextField";
import { InputLabel } from "Components/Base/Inputs/InputLabel";
import styled from "styled-components";

const StyledHoursAndMinutesTime = styled.div`
  margin: 8px 0 8px 0;

  fieldset {
    background: unset;
    box-shadow: unset;
    max-width: 70px;
  }
`;

/**
 * Renders a component for selecting hours and minutes.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.itemHours - The selected hours value.
 * @param {function} props.setItemHours - The function to update the selected hours value.
 * @param {string} props.itemMinutes - The selected minutes value.
 * @param {function} props.setItemMinutes - The function to update the selected minutes value.
 * @param {string} props.hourLabel - The label for hours.
 * @param {string} props.minutesLabel - The label for minutes.
 * @returns {JSX.Element} The rendered component.
 */
const HoursAndMinutesTime = ({
  itemHours,
  setItemHours,
  itemMinutes,
  setItemMinutes,
  hourLabel,
  minutesLabel,
}) => {
  const updateHours = (h) => {
    setItemHours(h.toString());
  };

  const updateMinutes = (m) => {
    setItemMinutes(m.toString());
  };

  hourLabel = `${upperCaseFirstLetter(hourLabel)}:`;
  minutesLabel = `${upperCaseFirstLetter(minutesLabel)}:`;

  return (
    <StyledHoursAndMinutesTime>
      <Box display="flex" sx={{ gap: "16px" }}>
        <Box
          display="flex"
          flexDirection="column"
          sx={{
            maxWidth: "75px",
          }}
        >
          <InputLabel htmlFor={hourLabel}>{hourLabel}</InputLabel>
          <TextField
            id={hourLabel}
            type="number"
            value={itemHours}
            width="auto"
            sx={{
              maxWidth: "75px",
            }}
            onChange={(event) => {
              updateHours(event.target.value);
            }}
            inputProps={{ type: "number", min: 0 }}
            placeholder="hh"
          />
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          sx={{
            maxWidth: "75px",
          }}
        >
          <InputLabel htmlFor={minutesLabel}>{minutesLabel}</InputLabel>
          <TextField
            id={minutesLabel}
            type="number"
            value={itemMinutes}
            width="auto"
            sx={{
              maxWidth: "75px",
            }}
            onChange={(event) => {
              updateMinutes(event.target.value);
            }}
            inputProps={{ type: "number", min: 0 }}
            placeholder="mm"
          />
        </Box>
      </Box>
    </StyledHoursAndMinutesTime>
  );
};

HoursAndMinutesTime.propTypes = {
  setItemHours: PropTypes.func.isRequired,
  hours: PropTypes.number,
  setItemMinutes: PropTypes.func.isRequired,
  minutes: PropTypes.number,
  hourLabel: PropTypes.string,
  minutesLabel: PropTypes.string,
};

HoursAndMinutesTime.defaultProps = {
  hours: 0,
  minutes: 0,
};

export default HoursAndMinutesTime;
